export function createAlias() {
    const randomAdj = adj[Math.floor(Math.random() * adj.length)];
    const randomNoun = noun[Math.floor(Math.random() * adj.length)];
    return `${randomAdj} ${randomNoun}`;
}

const adj = [
	"Able",
	"Accepting",
	"Adventurous",
	"Aggressive",
	"Ambitious",
	"Articulate",
	"Athletic",
	"Bold",
	"Brave",
	"Bright",
	"Busy",
	"Calm",
	"Careful",
	"Caring",
	"Cautious",
	"Cheerful",
	"Clever",
	"Compassionate",
	"Complex",
	"Confident",
    "Considerate",
    "Cooperative",
    "Courageous",
    "Creative",
    "Curious",
    "Dainty",
    "Daring",
    "Dark",
    "Determined",
    "Eager",
    "Efficient",
    "Energetic",
    "Excited",
    "Fair",
    "Faithful",
    "Forgiving",
    "Free",
    "Friendly",
    "Fun-loving",
    "Funny",
    "Generous",
    "Gentle",
    "Giving",
    "Gorgeous",
    "Gracious",
    "Handsome",
    "Happy",
    "Hard-working",
    "Helpful",
    "Honest",
    "Hopeful",
    "Humble",
    "Humorous",
    "Imaginative",
    "Impulsive",
    "Independent",
    "Intelligent",
    "Inventive",
    "Jealous",
    "Joyful",
    "Keen",
    "Kind",
    "Knowledgeable",
    "Light-hearted",
    "Likeable",
    "Lively",
    "Lovable",
    "Loyal",
    "Mature",
    "Merry",
    "Messy",
    "Mischievous",
    "Neat",
    "Organized",
    "Outgoing",
    "Passive",
    "Patient",
    "Patriotic",
    "Personable",
    "Pleasant",
    "Pleasing",
    "Popular",
    "Pretty",
    "Prim",
    "Proper",
    "Proud",
    "Questioning",
    "Quiet",
    "Radical",
    "Realistic",
    "Rebellious",
    "Reflective",
    "Relaxed",
    "Reliable",
    "Reserved",
    "Respectful",
    "Responsible",
    "Reverent",
    "Sarcastic",
    "Self-confident",
    "Sensible",
    "Sensitive",
    "Serious",
    "Shy",
    "Silly",
    "Smart",
    "Stable",
    "Strong",
    "Stubborn",
    "Studious",
    "Successful",
    "Tall",
    "Tense",
    "Thoughtful",
    "Thrilling",
    "Timid",
    "Tireless",
    "Tolerant",
    "Tough",
    "Tricky",
    "Trusting",
    "Understanding",
    "Unique",
    "Unlucky",
    "Unselfish", 
    "Warm", 
    "Wild", 
    "Wise",
    "Witty"];
const noun = [
    "Aardvark",
    "Albatross",
    "Alligator",
    "Alpaca",
    "Ant",
    "Anteater",
    "Antelope",
    "Armadillo",
    "Badger",
    "Barracuda",
    "Bat",
    "Bee",
    "Bison",
    "Boar",
    "Buffalo",
    "Butterfly",
    "Camel",
    "Capybara",
    "Caribou",
    "Cassowary",
    "Cat",
    "Caterpillar",
    "Cattle",
    "Chamois",
    "Cheetah",
    "Chinchilla",
    "Clam",
    "Cobra",
    "Cockroach",
    "Cod",
    "Cormorant",
    "Coyote",
    "Crab",
    "Crane",
    "Crocodile",
    "Crow",
    "Curlew",
    "Deer",
    "Dinosaur",
    "Dog",
    "Dogfish",
    "Dolphin",
    "Dotterel",
    "Dove",
    "Dragonfly",
    "Duck",
    "Dugong",
    "Dunlin",
    "Eagle",
    "Echidna",
    "Eel",
    "Eland",
    "Elephant",
    "Elk",
    "Emu",
    "Falcon",
    "Ferret",
    "Finch",
    "Fish",
    "Flamingo",
    "Fly",
    "Fox",
    "Frog",
    "Gaur",
    "Gazelle",
    "Gerbil",
    "Giraffe",
    "Gnu",
    "Goat",
    "Goldfinch",
    "Goldfish",
    "Goose",
    "Goshawk",
    "Grasshopper",
    "Grouse",
    "Guanaco",
    "Gull",
    "Hamster",
    "Hare",
    "Hawk",
    "Hedgehog",
    "Heron",
    "Herring",
    "Hippopotamus",
    "Hornet",
    "Horse",
    "Hummingbird",
    "Hyena",
    "Ibex",
    "Ibis",
    "Jackal",
    "Jaguar",
    "Jay",
    "Jellyfish",
    "Kangaroo",
    "Kingfisher",
    "Koala",
    "Kookabura",
    "Kouprey",
    "Kudu",
    "Lapwing",
    "Lark",
    "Lemur",
    "Leopard",
    "Lion",
    "Llama",
    "Lobster",
    "Locust",
    "Loris",
    "Lyrebird",
    "Magpie",
    "Mallard",
    "Manatee",
    "Mandrill",
    "Mantis",
    "Marten",
    "Meerkat",
    "Mink",
    "Mole",
    "Mongoose",
    "Moose",
    "Mosquito",
    "Mouse",
    "Narwhal",
    "Newt",
    "Nightingale",
    "Octopus",
    "Okapi",
    "Opossum",
    "Oryx",
    "Ostrich",
    "Otter",
    "Owl",
    "Oyster",
    "Panther",
    "Parrot",
    "Partridge",
    "Peafowl",
    "Pelican",
    "Penguin",
    "Pheasant",
    "Pigeon",
    "Pony",
    "Porcupine",
    "Porpoise",
    "Quail",
    "Quelea",
    "Quetzal",
    "Rabbit",
    "Raccoon",
    "Rail",
    "Ram",
    "Raven",
    "Red Panda",
    "Reindeer",
    "Rhinoceros",
    "Rook",
    "Salamander",
    "Salmon",
    "Sand Dollar",
    "Sandpiper",
    "Sardine",
    "Scorpion",
    "Seahorse",
    "Seal",
    "Shark",
    "Sheep",
    "Snail",
    "Snake",
    "Sparrow",
    "Spider",
    "Spoonbill",
    "Squid",
    "Squirrel",
    "Starling",
    "Stingray",
    "Stork",
    "Swallow",
    "Swan",
    "Tapir",
    "Tarsier",
    "Tiger",
    "Toad",
    "Trout",
    "Turtle",
    "Viper",
    "Vulture",
    "Wallaby",
    "Walrus",
    "Wildcat",
    "Wolf",
    "Wolverine",
    "Wombat",
    "Woodpecker",
    "Wren",
    "Yak",
    "Zebra"
]